var React = require('react');
var ReactDom = require('react-dom');
var cloneDeep = require('lodash/cloneDeep');
var slice = require('lodash/slice');
var moment = require('moment');
var Hammer = require('react-hammerjs').default;
var labels = require('NotificationsLabels');
var accountDataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');

class NotificationsDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: props.firstName,
            showDrawer: false,
            allNotifications: [],
            displayedNotifications: [],
            pendingDeletes: []
        };

        this.numberToDisplay = window.matchMedia("(min-width: 1025px)").matches ? 20 : 10;

        this.deleteNotification = this.deleteNotification.bind(this);
        this.fetchNotifications = this.fetchNotifications.bind(this);
        this.getHeaderButton = this.getHeaderButton.bind(this);
        this.getHeaderButtonClass = this.getHeaderButtonClass.bind(this);
        this.getNotifList = this.getNotifList.bind(this);
        this.getResultsNumberString = this.getResultsNumberString.bind(this);
        this.getResultsSummaryString = this.getResultsSummaryString.bind(this);
    }

    componentDidMount() {
        if (this.props.isLoggedIn) {
            this.fetchNotifications();
        }
    }

    fetchNotifications() {
        accountDataService.getData('accountNotifications').then((result) => {
            if (result && result.response && result.response.ResultStatus && result.response.ResultStatus.Success) {
                const validNotifs = result.response.CustomerWebNotification.filter((notif) => {
                    const date = notif.RemovalDateTime ? moment.utc(notif.RemovalDateTime).format('YYYY-MM-DD') : null;
                    return !notif.RemovalDateTime || date.isAfter(new Date());
                });

                this.setState({
                    allNotifications: validNotifs,
                    displayedNotifications: cloneDeep(slice(validNotifs, 0, this.numberToDisplay))
                });
            }
        });
    }

    deleteNotification(notificationId) {
        const deleteSuccess = (result) => {
            setTimeout(() => {
                if (result.response &&
                    result.response.ResultStatus &&
                    result.response.ResultStatus.Success &&
                    result.deleted) {

                    this.state.allNotifications = this.state.allNotifications.filter((notif) => notif.Id != result.deleted);

                    this.setState({
                        allNotifications: this.state.allNotifications,
                        displayedNotifications: cloneDeep(slice(this.state.allNotifications, 0, this.numberToDisplay))
                    });
                }

                this.state.pendingDeletes = this.state.pendingDeletes.filter((id) => id != notificationId);
                this.setState({
                    pendingDeletes: this.state.pendingDeletes
                });
            }, 2000);
        };

        if (notificationId) {
            this.state.pendingDeletes.push(notificationId);
            this.setState({
                pendingDeletes: this.state.pendingDeletes
            }, () => accountDataService.postData(accountDataService.deleteUrl.accountNotification(), notificationId).then(deleteSuccess));
        }
    }

    getHeaderButtonClass(mobile) {
        return mobile ? "accordionItemHeading" : "utility-nav-item";
    }

    getResultsNumberString() {
        if (this.state.displayedNotifications && this.state.displayedNotifications.length) {
            return this.state.displayedNotifications.length > 9 ? '9+' : this.state.displayedNotifications.length;
        }
    }

    getResultsSummaryString() {
        if (!this.props.isLoggedIn) {
            return '<a href="' + labels.logInUrl + '">' + labels.logInToSeeNotifications + '</a>';
        }

        const s = this.state.displayedNotifications.length > 1 ? 's' : '';

        return this.state.displayedNotifications.length > 0 ? labels.showing + ' ' + this.state.displayedNotifications.length + ' of ' + this.state.allNotifications.length + ' ' + labels.notification + s
            : labels.noNotifications;
    }

    getHeaderButton(mobile) {
        const resultsNumber = this.getResultsNumberString();
        const label = resultsNumber ? <label className={"marker"}>{resultsNumber}</label> : null;
        return <button className={this.getHeaderButtonClass(mobile)} key={"notif-button"}>
            {label}
            <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                <title>{labels.notificationsTitle}</title>
                <path d="M10 19.964c.119 0 .179-.06.179-.178 0-.12-.06-.179-.179-.179-.439 0-.817-.158-1.133-.474A1.546 1.546 0 0 1 8.393 18c0-.119-.06-.179-.179-.179s-.178.06-.178.179c0 .543.191 1.006.574 1.39.384.383.847.574 1.39.574zm-7.254-3.393h14.508c-1.979-2.232-2.968-5.327-2.968-9.285 0-.38-.09-.77-.268-1.172a4.264 4.264 0 0 0-.77-1.15c-.335-.364-.787-.664-1.356-.898A4.924 4.924 0 0 0 10 3.714c-.692 0-1.323.117-1.892.352-.569.234-1.02.534-1.356.898a4.264 4.264 0 0 0-.77 1.15 2.876 2.876 0 0 0-.268 1.172c0 3.958-.99 7.053-2.968 9.285zm16.54 0c0 .387-.142.722-.424 1.005a1.373 1.373 0 0 1-1.005.424h-5c0 .789-.279 1.462-.837 2.02a2.753 2.753 0 0 1-2.02.837 2.753 2.753 0 0 1-2.02-.837A2.753 2.753 0 0 1 7.143 18h-5c-.387 0-.722-.141-1.005-.424a1.373 1.373 0 0 1-.424-1.005c.372-.312.71-.64 1.016-.982.305-.342.621-.787.949-1.333.327-.547.604-1.137.831-1.77.227-.632.413-1.398.558-2.299.145-.9.218-1.867.218-2.901 0-1.131.435-2.182 1.306-3.153.87-.971 2.012-1.56 3.426-1.77a1.112 1.112 0 0 1-.09-.434c0-.298.105-.551.313-.76.208-.208.461-.312.759-.312s.55.104.759.313c.208.208.312.461.312.759 0 .148-.03.293-.089.435 1.414.208 2.556.798 3.426 1.769.871.97 1.306 2.022 1.306 3.153 0 1.034.073 2.001.218 2.902.145.9.331 1.666.558 2.299.227.632.504 1.222.831 1.769.328.546.644.991.95 1.333.304.343.643.67 1.015.982z" fill="#FFF" fillRule="evenodd" className={"bell-icon"} />
            </svg>
        </button>;
    }

    getNotifList(mobile) {
        /* Generate notifications but exclude any static messages (i.e. ID = 0) */

        const options = {
            direction: Hammer.DIRECTION_LEFT
        };

        const isPendingDelete = (id) => this.state.pendingDeletes.includes(id) ? ' is-pending-delete' : '';

        const list = this.state.displayedNotifications.map((notif) => {
            return notif.Show ? <Hammer onSwipe={() => this.deleteNotification(notif.Id)} options={options} key={notif.Id}>
                <li id={'notification-' + notif.Id} className={"notification-item" + isPendingDelete(notif.Id)}>
                    <div className={"notif-item"}>
                        {<div dangerouslySetInnerHTML={{ __html: notif.Message }} /> }
                        {notif.Id !== 0 ? (
                            <button className={"notif-close"} onClick={() => this.deleteNotification(notif.Id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 15 15" aria-label="close notification" focusable="false">
                                    <g strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="square">
                                        <path d="M2.004 2.144L12.721 12.86M12.791 1.87L1.518 13.145" />
                                    </g>
                                </svg>
                            </button>
                        ) : null}
                    </div>
                    <div className={'notif-swiper'}></div>
                </li>
            </Hammer> : null;
        });

        

        return mobile ?
            <div className={"accordionItemContent notification-dropdown"} key={"notif-dropdown"}>
                <span className={"summary"} dangerouslySetInnerHTML={{ __html: this.getResultsSummaryString() }} />
                <ul className={"notifications-menu"}>
                    {list}
                </ul>
            </div> :
            <div className={"utility-nav-dropdown dropdown notification-dropdown"} key={"notif-dropdown"}>
                <div className={"overlay-header"}>
                    <button tabIndex="-1" className="closeUtilityNav">
                        <div className="close">
                            <img src="/Images/Base/dist/icon-close-lrg.svg" alt=""/>
                        </div>
                    </button>
                </div>
                <h3>{labels.notificationsTitle}</h3>
                <span className={"summary"} dangerouslySetInnerHTML={{ __html: this.getResultsSummaryString()}} />
                <ul className={"utility-notifications"}>
                    {list}
                </ul>
                <button type="button" className="utility-notifications-button"><span className={"utility-notifications-icon"}>Toggle notifications height</span></button>
            </div>;
    }

    render() {
        const desktopButton = this.getHeaderButton(false);
        const mobileButton = this.getHeaderButton(true);

        const desktopList = this.getNotifList(false);
        const mobileList = this.getNotifList(true);

        const desktopNode = document.getElementsByClassName('notification-drawer-desktop')[0];
        const mobileNode = document.getElementsByClassName('notification-drawer-mobile')[0];

        if (!desktopNode) return null;

        return [ReactDom.createPortal([desktopButton, desktopList], desktopNode),
            ReactDom.createPortal([mobileButton, mobileList], mobileNode)];
    }
}

module.exports = NotificationsDrawer;